import { AppPagePaths } from "App/routes/paths";
import { lazyWithRetries } from "Utils/LazyWithRetries/LazyWithRetries";

import AudienceRoutingPage, { AudienceRerouter } from "./audienceRoutingPage";
import { audiencePathResources as audiencePaths } from "./Pages/audiencePaths";
import { audienceSegmentPageRoute } from "./Pages/SegmentsPage/Pages/segmentRoutes";

import type { RegalRouteObject } from "App/routes/types";

const ContactsPage = lazyWithRetries("Contacts page", () => import("./Pages/ContactsPage/ContactsPage"));

export const audienceRoute: RegalRouteObject = {
    path: AppPagePaths.audience,
    element: <AudienceRoutingPage />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <AudienceRerouter />,
        },
        {
            path: audiencePaths.contacts,
            element: <ContactsPage />,
        },
        {
            path: `${audiencePaths.segments}/*`,
            ...audienceSegmentPageRoute,
        },
    ],
};
